export default "__VITE_ASSET__BH6fLSAc__"